import styled from "styled-components";

const SalePointsPartnerPanelActionStyled = styled.div`

`;

export default SalePointsPartnerPanelActionStyled;